import React from "react";
import styles from "./FrequentlyQuestions.module.scss";
import { PUBLIC_IMAGE } from "../../constants";
import poolsStore from "../../stores/poolsStore";
import { observer } from "mobx-react-lite";
const FrequentlyQuestions = () => {
  return (
    <div className={`${poolsStore.isSubscribe ? styles.faqNone : styles.faq}`}>
      <div className={styles.faq__content}>
        <h2 className={styles.faq__title}>FAQ</h2>
        <details className={styles.faq__details}>
          <summary className={styles.faq__legend}>
            {" "}
            <p className={styles.faq__legendText}>
              1. What products are available?
            </p>
            <span className={styles.faq__icon}></span>{" "}
          </summary>
          <p className={styles.faq__listText}>
            The catalog includes staking, lending, spot markets, derivatives and tokenized assets.
          </p>
        </details>
        <details className={styles.faq__details}>
          <summary className={styles.faq__legend}>
            {" "}
            <p className={styles.faq__legendText}>
              2. Which cryptocurrencies are supported?
            </p>
            <span className={styles.faq__icon}></span>{" "}
          </summary>
          <p className={styles.faq__listText}>
            Popular assets are supported: Bitcoin (BTC), Ethereum (ETH), Tether
            (USDT), Litecoin (LTC), and more. The list expands as new networks
            and solutions are added.
          </p>
        </details>
        <details className={styles.faq__details}>
          <summary className={styles.faq__legend}>
            {" "}
            <p className={styles.faq__legendText}>
              3. Where does the market data come from?
            </p>
            <span className={styles.faq__icon}></span>{" "}
          </summary>
          <p className={styles.faq__listText}>
            Prices and rates come from the provider shown for each product. Unavailable values are not estimated.
          </p>
        </details>
        <details className={styles.faq__details}>
          <summary className={styles.faq__legend}>
            {" "}
            <p className={styles.faq__legendText}>
              4. What risks should I review?
            </p>
            <span className={styles.faq__icon}></span>{" "}
          </summary>
          <p className={styles.faq__listText}>
            Smart-contract, market, liquidity, eligibility and network risks are shown where confirmed.
          </p>
        </details>
        <details className={styles.faq__details}>
          <summary className={styles.faq__legend}>
            {" "}
            <p className={styles.faq__legendText}>
              5. When will operations be available?
            </p>
            <span className={styles.faq__icon}></span>{" "}
          </summary>
          <p className={styles.faq__listText}>
            Operations require durable reconciliation storage and a completed external-wallet signing flow.
          </p>
        </details>
        <details className={styles.faq__details}>
          <summary className={styles.faq__legend}>
            {" "}
            <p className={styles.faq__legendText}>
              6. What makes Alfa-Crypto different?
            </p>
            <span className={styles.faq__icon}></span>{" "}
          </summary>
          <p className={styles.faq__listText}>
            We provide access to staking and pools through transparent
            mechanisms and smart contracts, aggregating data from numerous
            platforms and sources to give users the most complete and up-to-date
            market view.
          </p>
        </details>
        <img
          src={PUBLIC_IMAGE + "faq-left-borderImage.svg"}
          alt=""
          className={styles.faq__imageLeft}
        />
        <img
          src={PUBLIC_IMAGE + "faq-left-borderMob.png"}
          alt=""
          className={styles.faq__imageLeftMob}
        />

        <img
          src={PUBLIC_IMAGE + "faq-right-borderImage.svg"}
          alt=""
          className={styles.faq__imageRight}
        />
        <img
          src={PUBLIC_IMAGE + "faq-right-borderMob.png"}
          alt=""
          className={styles.faq__imageRightMob}
        />
      </div>
      <div className={`${styles.faq__imageLeft} ${styles.faq__backgroundLeft}`}>
        <img
          src={PUBLIC_IMAGE + "faq-backgroundImage.svg"}
          alt="faq-backgroundImage"
        />
      </div>
      <div
        className={`${styles.faq__imageRight} ${styles.faq__backgroundRight}`}
      >
        <img
          src={PUBLIC_IMAGE + "faq-backgroundImage.svg"}
          alt="faq-backgroundImage"
        />
      </div>
    </div>
  );
};

export default observer(FrequentlyQuestions);
